import { render, staticRenderFns } from "./T-F-Under-Grad-2024-EN.vue?vue&type=template&id=589aa8a4&scoped=true&"
import script from "./T-F-Under-Grad-2024-EN.vue?vue&type=script&lang=js&"
export * from "./T-F-Under-Grad-2024-EN.vue?vue&type=script&lang=js&"
import style0 from "./T-F-Under-Grad-2024-EN.vue?vue&type=style&index=0&id=589aa8a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589aa8a4",
  null
  
)

export default component.exports